var _rect, _g, _rect2, _polygon, _polygon2, _g2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountArc21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155.9px",
    height: "195px",
    viewBox: "0 0 155.9 195",
    enableBackground: "new 0 0 155.9 195",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    y: 0.1,
    fill: "#FFFFFF",
    width: 155.9,
    height: 194.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 29.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 106.3,
    height: 147.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6,
    y: 38.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 88.8,
    height: 130
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.2,
    y: 50.8,
    fill: "#474746",
    width: 0,
    height: 9.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.2411,
    strokeMiterlimit: 10,
    points: "16.9,15.9 17.1,12.3 -0.1,12.3  4.6,15.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.2411,
    strokeMiterlimit: 10,
    points: "138.9,16 151.2,16 155.9,12.4  138.8,12.4 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    stroke: "#606161",
    strokeMiterlimit: 10,
    d: "M17.1,134.3c0,0-0.5,0.2-0.6,0.9s-0.1,2.9-0.1,2.9 s-0.1,0.7,0.7,0.9c0.8,0.3,4.9,1.2,6.2,1.5c1.3,0.3,9.6,2.5,11.9,2.9s11.9,2.1,13.9,2.4c2,0.3,16.7,1.8,19.6,1.9 c2.9,0.1,16.9-0.1,18.9,0s11.6-0.7,13.7-0.9c2.1-0.2,13.7-2.1,14.7-2.3c1-0.2,15.5-3.5,16.2-3.8s6.3-1.9,6.6-2 c0.4-0.1,0.7-0.2,0.8-1s0.1-2.3,0.1-2.3s0.1-0.4-0.1-0.5s-0.7-0.3-0.7-0.3l-10.7,2.8l-13.9,2.6l-17.7,2.4l-22.1,0.7l-24.6-2.4 l-21-4l-11.2-3L17.1,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    stroke: "#606161",
    strokeMiterlimit: 10,
    d: "M17.4,129.5c0,0-0.8,0.4-0.8,1s0,2.8,0,2.8s-0.3,0.6,0.5,0.8 c0.7,0.2,5,1.7,6.2,1.9s12.8,2.8,15.4,3.4c2.5,0.6,17.7,3,21.5,3.2c3.8,0.3,17.8,1.1,17.8,1.1s18-0.7,20.6-1.1 c2.5-0.3,19-2.6,21.3-3s15.2-3.5,17.1-4s2.4-0.8,2.4-0.8s0.6,0,0.6-1.3c0-1.3,0-2.4,0-2.4s-0.1-0.9-0.8-0.9s-0.6-0.3-0.6-0.3 l-6.9,1.9l-24,5L89.8,139l-18-0.2l-10-0.3l-12.6-1.7l-17.2-3.4l-12.2-3.7l-2.1-0.6L17.4,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    stroke: "#606161",
    strokeMiterlimit: 10,
    d: "M17.3,124.2c0,0-0.9,0.4-0.9,1.6s0,2,0,2s-0.2,0.9,0.9,1.4 c1.1,0.5,7.4,2.6,8.9,3c1.5,0.4,18.6,4.6,22.5,5.1c4,0.5,22.3,2.2,30.6,2.1c8.3-0.2,29-2.2,30.6-2.4c1.6-0.2,13.7-2.5,15-2.8 c1.3-0.3,13.3-3.9,14.1-4.2c0.8-0.3,0.8-0.4,0.8-1.6c0-1.2,0.1-2.2-0.4-2.9c-0.5-0.7-1-0.9-1-0.9l-0.6-0.5l-26.4,5.6L96.4,132 l-20.7,0.7l-14.2-1l-15.7-2.5l-27.9-5.5L17.3,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    stroke: "#606161",
    strokeMiterlimit: 10,
    d: "M17,11.3h121.4V109c0,0,1.4,5.3,1.4,8.3c0,3,0,5.1,0,5.1 s0.4,1.6-2,2.2s-9.5,2.5-15.1,3.6c-5.6,1.1-25.6,4.3-29.1,4.5c-3.5,0.2-19.9,0.7-27.4,0s-28.6-4.1-32.6-4.9c-4-0.9-15-3.6-16.1-3.9 c-1.1-0.3-1.8-0.7-1.4-4.1c0.4-3.4,1-7.3,1-9.1C17.1,108.9,17,11.3,17,11.3z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    y: 0.2,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.2174,
    strokeMiterlimit: 10,
    width: 155.9,
    height: 12.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountArc21);
export default __webpack_public_path__ + "static/media/mount_arc21.628eba8270f3edb487569a326eab95b6.svg";
export { ForwardRef as ReactComponent };